import React from 'react'
import './activate.scss';

const ActivateSkeleton = () => {

    return (
            <div className='wkit-active-content'>
                <div className='wkit-credit-detail'>
                    <div className='wkit-credit-chart-skeleton'>
                        <div className='wkit-center-chart-skeleton'></div>
                    </div>
                    <div className='wkit-credit-meta'>
                        <div className='wkit-credit-meta-header-skeleton'>
                          
                        </div>
                        <div className='wkit-credit-meta-body'>
                            <div className='wkit-credit-meta-content'>
                                <div className='wkit-credit-meta-content-top'>
                                    <div className='wkit-active-dot-skeleton'>
                                    </div>
                                    <div className='wkit-active-line-skeleton'></div>
                                </div>
                                <div className='wkit-credit-meta-skeleton-bottom'>
                                </div>
                            </div>
                            <div className='wkit-credit-meta-content'>
                                <div className='wkit-credit-meta-content-top'>
                                    <div className='wkit-active-dot-skeleton'>
                                    </div>
                                    <div className='wkit-active-line-skeleton'></div>
                                </div>
                                <div className='wkit-credit-meta-skeleton-bottom'>
                                </div>
                            </div>
                            <div className='wkit-credit-meta-content'>
                                <div className='wkit-credit-meta-content-top'>
                                    <div className='wkit-active-dot-skeleton'>
                                    </div>
                                    <div className='wkit-active-line-skeleton'></div>
                                </div>
                                <div className='wkit-credit-meta-skeleton-bottom'>
                                </div>
                            </div>
                        </div>
                        <button className='wkit-credit-meta-btn wkit-btn-skeleton'>
                        </button>
                    </div>
                </div>
                <div className='wkit-apiKey-content'>
                    <div className='wkit-apiKey-add-content'>
                        <div className='wkit-addKey-header-skeleton'>

                        </div>
                        <div className='wkit-addKey-content-skeleton'>
                            <span></span>
                            <div className='wkit-addKey-body'>
                               <div className='wkit-addkey-input-skeleton'></div> 
                                <button>
                                </button>
                                <a></a>
                            </div>
                        </div>
                    </div>
                    <div className='wkit-apiKey-table-content'>
                        <div className='wkit-apiKey-table-header-skeleton'>
                            <span></span>
                            <p></p>
                        </div>
                        <div className='wkit-apiKey-table-body'>
                            <table>
                                <thead>
                                    <tr className='wkit-table-hraders-skeleton'>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                
                            </table>
                        </div>
                    </div>
                </div>
            </div>
    )
}
export default ActivateSkeleton;
